/**
 * Roles available for portal (organization) users
 */
export enum PortalRole {
  ORGANIZATION_ADMIN = 'OrganizationAdmin',
  MERCHANT_ADMIN = 'MerchantAdmin',
  FINANCE = 'Finance',
  CUSTOMER_SUPPORT = 'CustomerSupport',
}

/**
 * Type guard to check if a string is a valid PortalRole
 */
export const isPortalRole = (role: string): role is PortalRole => {
  return Object.values(PortalRole).includes(role as PortalRole);
};
